import { _DATEFORMATS } from "../../shared/consts";
import { getFullName } from "../../shared/utils";
import fileSys from "../../fileoprators/fileSystem";
const state = {
  currPatientName: "",
  loginState: false,
  currentEyeType: "OD",
  pID: "", // 病例唯一标识ID,
  dateFormat: _DATEFORMATS[window.settings.dateFormat].label,
  isHasUrl: getQueryString("type"),
  vncControl: false
};

const mutations = {
  PATIENT_NAME_CHANGED: (state, patient) => {
    state.currPatientName = getFullName(patient);
  },
  DATE_FORMAT_CHANGED: (state, dateFormat) => {
    state.dateFormat = dateFormat;
  },
  LOGIN_STATE_CHAGNED: (state, flag) => {
    state.loginState = flag;
  },
  CURRENT_EYETYPE_CHNAGED: (state, eyetype) => {
    state.currentEyeType = eyetype;
  },
  VNC_CONTROL: (state, flag) => {
    state.vncControl = flag;
  }
};
const actions = {
  patientNameChanged({ commit }, patient) {
    commit("PATIENT_NAME_CHANGED", patient);
  },
  loginStateChanged({ commit }, flag) {
    commit("LOGIN_STATE_CHAGNED", flag);
  },
  currentEyeTypeChanged({ commit }, eyetype) {
    commit("CURRENT_EYETYPE_CHNAGED", eyetype);
  },
  dateFormatChanged({ commit }, dateFormat) {
    commit("DATE_FORMAT_CHANGED", dateFormat);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};

function getQueryString(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js